import $ from 'jquery';
import { getImagePath } from "@/config/imgConfig";
import {mapGetters,mapActions} from 'vuex'
import { request } from '@/config/api01'
export default {
	data (){
		return {
			noHeaderScrollerStyle: {},
			pageHeaderHeight: 88,
			userInfo: {
				// userid:'fca65d5d172afee44c395112e545ed93fa63f671',
				// userid:'1d6c7cf217c19e40d6f4a322d67eefaa16dcb255', // 13353437863
				userid:'',
				tel:''
			},
			isIPhoneX:false,
			perW:'',
			disW:'',
			imageobj:{},
			platform:'ios',
			levelid:'',
			language:'',
			isgetglobal:false,
			version:'',
			isIOS:true,
			isAndriodX:false,
			isiPad:false,
			isfunbook:false
		}
	},
	computed:{
		...mapGetters(['userinfo'])
	},
	created (){
		this.imageobj = window.imagearr;
		
		
		(function() {
			if (typeof WeixinJSBridge == "object" && typeof WeixinJSBridge.invoke == "function") {
				handleFontSize();
			} else {
				if (document.addEventListener) {
					document.addEventListener("WeixinJSBridgeReady", handleFontSize, false);
				} else if (document.attachEvent) {
					document.attachEvent("onWeixinJSBridgeReady", handleFontSize);
				}
			}
			function handleFontSize() {
				// 设置网页字体为默认大小
				WeixinJSBridge.invoke('setFontSizeCallback', { 'fontSize' : 0 });
				// 重写设置网页字体大小的事件
				WeixinJSBridge.on('menu:setfont', function() {
					WeixinJSBridge.invoke('setFontSizeCallback', { 'fontSize' : 0 });
				});
			}
		})();
		
		var w = $(window).width();
		var h = $(window).height();

		var h1 = h/750;
		var w1 = h1*1624;


		var perW = ((w1/w)*100).toFixed(2) + '%'; 

		this.perW = perW+' 100%'
		this.disW = '50%'
	},
	mounted() {
		Date.prototype.format = function (fmt) {
			var o = {
				"M+": this.getMonth() + 1,                   //月份
				"d+": this.getDate(),                        //日
				"h+": this.getHours(),                       //小时
				"m+": this.getMinutes(),                     //分
				"s+": this.getSeconds(),                     //秒
				"q+": Math.floor((this.getMonth() + 3) / 3), //季度
				"S": this.getMilliseconds()                  //毫秒
			};

			//  获取年份 
			// ①
			if (/(y+)/i.test(fmt)) {
				fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
			}

			for (var k in o) {
				// ②
				if (new RegExp("(" + k + ")", "i").test(fmt)) {
				fmt = fmt.replace(
					RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
				}
			}
			return fmt;
		}
	},
	methods: {
		...mapActions(['setinfo']),
		getpath(name, type) {
			return getImagePath(name, type, false);
		},
		jumpInter(to) {
			if (this.$router) {
				this.$router.push(to)
			}
		},
		gotodown(type){
			if(type == 'correct'){
				window.location.href = 'https://jojosila.stagekids.cn/JojoSila/webtest/course/correctShare/#/Home?source=8_1'
			}else if(type == 'growup'){
				window.location.href = 'https://www.uummii.life/down/growInfoweb/#/Home?source=9_1'
			}else if(type == 'stick'){
				window.location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=cn.stagekids.app.wordcorrection.android'
			}else if(type == 'buy'){
				request({
					url: '/StageKids/client/content.php?act=getWechatshopURLScheme',
				}).then((response) => {
					let content = response.data.URLScheme;
					setTimeout(() => {
						window.location.href = content;
					}, 200);
					
				});
			}
		},
		// object 转 URL 参数
		createQuery(obj) {
			if(obj === null || obj === undefined || obj === "" || obj.length === 0 ) {
				return ""
			}
			let url = '?';
			for (let key in obj) {
				if (obj[key] !== null) {
					if(typeof obj[key] == 'string'){
						url += (key + '=' + encodeURIComponent(obj[key]) + '&');
					}else{
						url += (key + '=' + encodeURIComponent(JSON.stringify(obj[key])) + '&');
					}
				}
			}
			return url.substring(0, url.lastIndexOf('&'));
		},
		// 'xxx.js?name=aa' 转 {name: 'aa'}
		getQueryData(url) {
			url = url.substring(url.indexOf('.js?') + 3);
			let result = {};
			if (url.indexOf("?") != -1) {
				let str = url.substr(1);
				let strs = str.split("&");
				for (let i = 0; i < strs.length; i++) {
					try{
						result[strs[i].split("=")[0]] = JSON.parse(decodeURIComponent(strs[i].split("=")[1]));
					}catch (error){
						result[strs[i].split("=")[0]] = decodeURIComponent(strs[i].split("=")[1]);
					}
				}
			}
			return result;
		},
		getuserinfo(userinfo){
			var str = JSON.stringify(userinfo);
			var obj = JSON.parse(JSON.stringify(userinfo))
			this.userInfo = obj;
		},
		// 打乱数组的方法
		randArr(arr) {
			let needArr = arr.slice(0,arr.length);
			for (var i = 0; i < needArr.length; i++) {
				var iRand = parseInt(needArr.length * Math.random());
				var temp = needArr[i];
				needArr[i] = needArr[iRand];
				needArr[iRand] = temp;
			}
			return needArr;
		},
	}
}



// WEBPACK FOOTER //
// ./src/mixins/index.js